<template>
  <v-card>
    <v-card-text>
      <iframe
        width="640"
        height="426"
        src="https://player.vimeo.com/video/329223533"
        frameborder="0"
        allow="fullscreen"
        allowFullScreen
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="$emit('close')"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'VideoCard',
};
</script>
